export default __webpack_public_path__ + "static/media/searchHV.ca205fe9.svg";